import {
  AVATAR_ERROR_MESSAGES,
  AVATAR_ERROR_TYPE,
  type AvatarEditorAlert,
} from 'src/components/common/DoctorAvatarEditor/constants'

type RequestErrorLike = {
  message?: string
  response?: {
    status?: number
    statusText?: string
    data?: unknown
  }
}

type DjangoErrorItem = Record<string, { code?: string } | undefined>

function isRequestErrorLike(error: unknown): error is RequestErrorLike {
  return typeof error === 'object' && error !== null
}

function isNetworkDisconnect(error: unknown) {
  if (!process.env.IS_CLIENT || !isRequestErrorLike(error)) {
    return false
  }

  return error.response?.status === 0
    || !window.navigator.onLine
    || error.message === 'Network Error'
}

function getNonFieldErrorCode(data: unknown) {
  if (!Array.isArray(data) || !data.length) {
    return ''
  }

  const [firstError] = data as DjangoErrorItem[]
  const nonFieldErrors = firstError?.non_field_errors

  return nonFieldErrors?.code || ''
}

/**
 * Сообщение для алерта по ответу process/save аватара.
 *
 * Коды `non_field_errors` с бэкенда мапятся на готовые тексты;
 * сеть и пустой 400 — на отдельные сообщения.
 */
export default function getAvatarEditorError(error: unknown): AvatarEditorAlert {
  const fallback = AVATAR_ERROR_MESSAGES[AVATAR_ERROR_TYPE.other]

  if (isNetworkDisconnect(error)) {
    return AVATAR_ERROR_MESSAGES[AVATAR_ERROR_TYPE.notNetwork]
  }

  if (!isRequestErrorLike(error)) {
    return fallback
  }

  const { data, status } = error.response || {}
  const code = getNonFieldErrorCode(data)

  if (code && AVATAR_ERROR_MESSAGES[code]) {
    return AVATAR_ERROR_MESSAGES[code]
  }

  if (status === 400) {
    return AVATAR_ERROR_MESSAGES[AVATAR_ERROR_TYPE.onModeration]
  }

  return fallback
}
